import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {appInjector} from "../../appInjector";
import {ItemEvent} from "../../ItemEvent";
import {ToolsService} from "../../../services/toolsService/tools.service";
import {CesiumAdapterService} from "../../../services/cesiumAdapter21/cesium-adapter.service";
import {MapTextOverlay} from "./MapTextOverlay";
import {BabyNumber} from "../BabyPlugin/BabyNumber";
import {MapObjectPlugin} from "../MapObjectPlugin";
import {MapPosition} from "../../../models/MapPosition";
import {ItemConfig} from "../../../models/ItemConfig";
import {debounceTime} from "rxjs/operators";
import {UiAdapterService} from "../../../services/uiAdapterService/ui-adapter.service";
import {ObjectConfig} from "../../../models/ObjectConfig";
import {ViewRef} from "@angular/core";
import {RotateObjectService} from "../../../services/rotateService/rotate-object.service";
import {Subscription, timer} from "rxjs";


export class MapTextOverlayPlugin extends AbstractMainPlugin {


  private tool;
  private view;
  private rotateService;
  private currentDiv:HTMLElement;
  private isInitialized = false;
  private currentInputHash = null;
  private trackOverlaySize = false;
  public mapOverlay:MapTextOverlay;
  public currentInput = null;
  public currentInputName = null;
  public fixedHeight = null;
  private uiAdapter:UiAdapterService = null;
  private isInZoom = false;
  private isPolygon = false;
  private afterDraw = false;
  private tilesLoaded = false;
  private isDynamicCodeObject = false;
  private currentAnchorPosition = null;
  private currentSubscriptions:Subscription;

  // private currentTool;
  private isSelected = false;

  static getBeforeItemComponents() {
    return [];
  }


  private initListeners(){
    this.view.onOverlayChangePosition.subscribe((config)=>{
      if (this.mapOverlay && this.mapOverlay.id == config.id){
        this.afterDraw = true;
        this.item.config.setInputValue(this.currentInputName, 'mapLabelPosition', config.position);
      }
    });

    this.item.getSubject(Item.LABEL_VISIBILITY).subscribe((flag)=>{
      if (this.mapOverlay && this.item.config.getTool().dynamic_image_code && this.item.config.getTool().dynamic_image_code.trim().length == 0){
        this.mapOverlay.setLabelDisabledValue(!flag);
      }
    });

    this.item.getObservable('toolSwitched').subscribe(()=>{
      timer(500).subscribe(()=>{
        this.isInitialized = false;
        if (this.mapOverlay){
          this.mapOverlay.removeTextOverlay();
          this.mapOverlay.removeTextOverlayLine();
          this.currentSubscriptions.unsubscribe();
          delete this.mapOverlay;
        }
        this.currentSubscriptions = new Subscription();
        this.afterDrawInit(this.currentAnchorPosition);
      })
    });

    this.item.getSubject(MapObjectPlugin.ANCHOR_SUBJECT).subscribe((anchorPosition:MapPosition|MapPosition[]) => {
      this.currentAnchorPosition = anchorPosition;
      if (this.isInitialized && this.mapOverlay) {
        // this.mapOverlay.overlayChangePosition(anchorPosition, this.prepareOptions());
        return;
      }


      this.item.getSubject(Item.AFTER_DRAWN_SUBJECT).subscribe((success)=>{
        console.log('Item.AFTER_DRAWN_SUBJECT');
        this.currentSubscriptions = new Subscription();
        this.afterDrawInit(anchorPosition)
        // console.log('after_drawn_subject');
      });
    });

    this.item.config.subject.subscribe((newConfig)=>{
      this.onConfigUpdated(newConfig);
      this.afterDraw = false;
    });

    this.item.config.serverUpdate.subscribe((newConfig)=>{
      this.onConfigUpdated(newConfig);
    });

    // this.view.zoom.pipe(debounceTime(500)).subscribe((zoomLevel)=>{
    //   this.isInZoom = false;
      // if (zoomLevel && this.currentInput && Array.isArray(this.currentInput.mapLabelCSSStyle)){
      //   let config = null;
      //   for (let i = 0; i < this.currentInput.mapLabelCSSStyle.length; i++){
      //     config = this.currentInput.mapLabelCSSStyle[i];
      //     if (this.checkIsInZoom(zoomLevel, config)){
      //       this.isInZoom = true;
      //       break;
      //     }
      //   }
      //   (this.isInZoom) ? this.mapOverlay.setOverlayStyles(config.css) : '';
      // }

    // });
  }

  private afterDrawInit(anchorPosition){
    let hasCssFields = false;
    if (!this.isInitialized) {
      for (let i in this.item.config.getInputs()) {
        if (this.item.config.getInputByName(i)) {
          if (i.indexOf('_css_') >= 0) {
            hasCssFields = true;
          }

          if (window['BILLBOARD_DYNAMIC_FIGURES_ALLOWED']) {
            if (i == '__url_for_dynamic_icon' || i == '__dynamic_image_code') {
              continue;
            }
          }

          let currentInp = this.item.config.getInputByName(i);
          if (i != '__baby_number' && currentInp.hasOwnProperty('showOnMap') && currentInp.showOnMap) {
            this.mapOverlay = new MapTextOverlay(this.view, `map-text-label-id-${this.item.getId()}`, anchorPosition, currentInp, i);
            this.fixedHeight = this.item.config.getObjectConfig().getFixedHeight();
            this.currentSubscriptions.add(this.mapOverlay.isCreated$.subscribe(()=>{
              this.item.getSubject('overlayDrawn').next(true);
            }));
            this.currentInput = currentInp;

            this.trackOverlaySize = this.currentInput.trackOverlaySize || false;

            if (this.currentInput.labelImage) {
              this.currentInput.labelImage = this.currentInput.labelImage
                .replace("{MAP_ICON}", this.tool.map_icon)
                .replace("{MENU_ICON}", this.tool.menu_icon)
              ;
            }

            this.currentInputHash = JSON.stringify(this.currentInput);
            this.currentInputName = i;
            if (i == '__dynamic_image_code'){
              this.isDynamicCodeObject = true;
            }
            break;
          }
        }
      }

      if (this.mapOverlay && this.currentInput) {
        this.mapOverlay.createTextOverlay(this.currentInput.anchor || 'TOP_LEFT', this.prepareOptions());
        if (this.currentInput.hasOwnProperty('lineStyle')) {
          var subscribeTiles = this.view.tilesLoaded.pipe(debounceTime(1000)).subscribe((status)=>{
            if (status && !this.tilesLoaded && !this.mapOverlay.hasLineOverlay){
              this.mapOverlay.createTextOverlayLine(this.currentInput, this.currentInput.anchor || 'TOP_LEFT', this.prepareOptions());
              this.tilesLoaded = true;
            }

            if (this.mapOverlay.hasLineOverlay && subscribeTiles){
              subscribeTiles.unsubscribe();
            }

            if (!status){
              this.tilesLoaded = false;
            }
          });
        }


            this.mapOverlay.setTextOverlay(this.currentInput.value || this.currentInput.labelImage || '');
            console.log('mapLabelCSSStyle', this.currentInput.mapLabelCSSStyle, this.currentInput);
            this.mapOverlay.setOverlayStyles(this.currentInput.mapLabelCSSStyle || null);
            //
            this.currentSubscriptions.add(this.item.getSubject(Item.SUBJECT_VISIBILITY).subscribe((val) => {
              this.mapOverlay.setMainVisibility(val);
            }));
            //
            this.currentSubscriptions.add(this.item.emitter.subscribe((event) => {
              if (event.getEventName() == 'removeObject' && this.mapOverlay) {
                this.mapOverlay.removeTextOverlay();
                this.mapOverlay.removeTextOverlayLine();
              }
            }));

        this.currentSubscriptions.add(this.mapOverlay.clickOnObject.subscribe(()=>{
          this.uiAdapter.selectedItem$ = this.item;
        }));
        //
        this.currentSubscriptions.add(this.mapOverlay.overlayDragStart.subscribe(()=>{
          if (this.item.drag_enabled){
            this.mapOverlay.dragStart();
          }
        }));

        this.currentSubscriptions.add(this.mapOverlay.overlayDragged$.subscribe(()=>{
          clearTimeout(this.item.timer);
          if (!this.uiAdapter.globalDragEnabled) {
            this.item.drag_enabled = true;
            this.item.timer = setTimeout(() => {
              this.item.drag_enabled = false;
              this.item.timer = null;
            }, 10000);
          }
        }));

        if (this.trackOverlaySize){
          this.currentSubscriptions.add(this.view.cameraEventMoveEnd.subscribe(()=>{
            if (this.mapOverlay.globalVisibility && !this.mapOverlay.isDisabledLabel){
              this.mapOverlay.calculateTrackOverlaySize(this.item.config);
            }
          }))
        }
        else{
          this.mapOverlay.applyCssFromInputs(this.item.config, this.item.config.getObjectConfig().getCenterPosition());
          this.currentSubscriptions.add(this.view.cameraEventMoveEnd.subscribe(()=>{
            if (this.mapOverlay.globalVisibility && !this.mapOverlay.isDisabledLabel){
              this.mapOverlay.applyCssFromInputs(this.item.config, this.item.config.getObjectConfig().getCenterPosition());
            }
          }))
        }

        if (this.currentInput.__isObject && this.currentInput.__isObject.value && !this.isDynamicCodeObject){
          console.log('__isObject');
          this.currentDiv = document.querySelector('#map-text-label-id-'+this.item.getId());
          this.currentDiv.classList.add('es-label-item');

          this.currentSubscriptions.add(this.item.getSubject('overlayDrawn').subscribe(()=>{
            this.rotateLabel();
          }));

          this.currentSubscriptions.add(this.uiAdapter.selectedItem$.subscribe((item)=>{
            this.isSelected = item instanceof Item && item.getId() == this.item.getId();
            if (!(item instanceof Item) ){
              this.isSelected = false;
            }
          }));

          this.currentSubscriptions.add(this.rotateService.objectRotated$.subscribe((rotateDegrees)=>{
            if (this.isSelected){
              this.rotateLabel(rotateDegrees);
            }
          }));

          this.currentSubscriptions.add(this.view.onOverlayChangePosition.subscribe((config)=>{
            if (this.isSelected && config.id == 'map-text-label-id-'+this.item.getId()){
              this.item.config.getObjectConfig().setPosition(config.position);
            }
          }))
        }
      }
    }
    this.isInitialized = true;
  }

  private rotateLabel(rotation?){
    if (!rotation && rotation != 0){
      rotation = this.item.config.getRotation();
      const cssConfig = this.item.config.getInputProp(this.currentInputName, 'mapLabelCSSStyle');
      cssConfig.transform = 'translate(-50%, -50%) rotate(' + rotation + 'deg)';
      this.item.config.setInputValue(this.currentInputName, 'mapLabelCSSStyle', cssConfig);
    } else {
      if (this.currentDiv){
        this.currentDiv.style.transform = 'translate(-50%, -50%) rotate('+rotation+'deg)';
      }
    }
  }

  private prepareOptions(){
    return {
      margins: this.currentInput.hasOwnProperty('mapLabelMargins') ? this.currentInput.mapLabelMargins : [0, 0],
      positionType: this.currentInput.hasOwnProperty('mapLabelPositionType') ? this.currentInput.mapLabelPositionType : 'px',
      fixedPosition: this.currentInput.hasOwnProperty('mapLabelPosition') ? this.currentInput.mapLabelPosition : null,
      widthInMeters: this.currentInput.hasOwnProperty('widthInMeters') ? this.currentInput.widthInMeters : null,
      heightInMeters: this.fixedHeight,
      trackOverlaySize: this.trackOverlaySize,
      isPolygon: this.isPolygon
    };
  }

  constructor(item:Item) {
    super(item);

    this.view = appInjector.get(CesiumAdapterService);
    this.rotateService = appInjector.get(RotateObjectService);
    this.tool = item.config.getTool();
    this.uiAdapter = appInjector.get(UiAdapterService);

    this.isPolygon = this.tool.type == ObjectConfig.TYPE_POLYGON;
    this.initListeners()
  }

  private updateValues(input){
    if (this.mapOverlay && input){
       this.mapOverlay.overlayChangePosition(null, this.prepareOptions(), this.afterDraw);
      this.mapOverlay.setTextOverlay(input.value || input.labelImage || '');
      if (!this.afterDraw){
        this.mapOverlay.setOverlayStyles(input.mapLabelCSSStyle || null);
        this.view.showTextOverlay(this.mapOverlay.overlay);
      }
    }
  }

  private onConfigUpdated(newConfig:ItemConfig){
    if (!this.mapOverlay){
      return;
    }

    let input = newConfig.getInputByName(this.currentInputName);

    if (input.trackOverlaySize){
      this.trackOverlaySize = input.trackOverlaySize;
      this.mapOverlay.calculateTrackOverlaySize(this.item.config);
    }


    this.mapOverlay.overlayChangePosition(newConfig.getObjectConfig().getPosition(), this.prepareOptions());

    this.view.raiseCameraEvent('moveEnd');

    if (this.currentInputHash == JSON.stringify(input)){
      return;
    }

    if (!input){
      this.mapOverlay.setTextOverlay(null);
      return;
    }

    this.updateValues(input);

    this.currentInputHash = JSON.stringify(input);
    this.currentInput = input;
  }

  private checkIsInZoom(zoomLevel, config):boolean{
    return config.min <= zoomLevel && config.max >= zoomLevel;
  }

}

